// extracted by mini-css-extract-plugin
export default {"pageContainer":"UserResearch_pageContainer__t7jh1","mainGrid":"UserResearch_mainGrid__aNF9k","textInput":"UserResearch_textInput__4Qz-c","urlInput":"UserResearch_urlInput__C+Im2"};